import React from 'react';
import './AppTradeDateModal.scss';

const AppTradeDateModal = () => (
  <div className="as-of-modal">
    <h1>A Note on Projected Trade Date</h1>
    <h4>
      Under normal circumstances, trade requests will be processed as follows:
    </h4>
    <div className="body-text">
      <ul>
        <li>
          Withdrawal requests received by 12 p.m. ET on a business day* will be
          processed and executed on the same day.
        </li>
        <li>
          Withdrawal requests received between 12 p.m. and 3 p.m. ET on a
          business day* will be made on a best-efforts basis on the same day.
        </li>
        <li>
          Withdrawal requests received after 3 p.m. ET on a given business day*
          will be processed the next business day.
        </li>
        <li>
          Withdrawal requests received on non-business days will be processed on
          the next business day.*
        </li>
        <li>
          Full account closeout requests received by 12 p.m. ET on a given
          business day* will generally be processed and executed two or more
          business days after the request is made; however, depending on the
          nature and timing of the request, certain full closeouts may take
          longer to fully process.
        </li>
      </ul>
    </div>
    <div className="asterisk">
      *A business day is one on which the New York Stock Exchange is open.
    </div>
  </div>
);

export default AppTradeDateModal;
